import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { Grafico } from '../../model/chart.model';

@Component({selector: 'app-chart', templateUrl: './chart.component.html'})
export class ChartComponent implements OnInit, OnChanges {

  // Variável que recebe os dados do gráfico
  @Input() data: Grafico;

  // Variável para definir visibilidade do gráfico
  visible: boolean;

  // Variável para setar as configurações de cores do chart
  chartColors: any[];

  // Variável para setar as configurações do chart
  options: any;

  // label do gráfico
  labels: any[];

  // Tipo do gráfico
  type: string;

  // Variable to hold datasets input
  datasets: any[];

  constructor(private decimalPipe: DecimalPipe) { }

  ngOnInit() { }

  ngOnChanges(changes: any) {

    // Atualizar os valores dos gráficos.
    if (changes.data.currentValue) {
        this.labels = changes.data.currentValue.labels;

        // Setar o tipo do gráfico
        this.type = changes.data.currentValue.tipo === undefined ? 'bar' : changes.data.currentValue.tipo;

        // // setar cores

        if (this.type !== 'line') {
          this.datasets = [
            {
              type: this.type,
              data: changes.data.currentValue.values,
              label: changes.data.currentValue.titulo,
              backgroundColor: changes.data.currentValue.backgroundColor,
              borderColor: changes.data.currentValue.backgroundColor,
              hoverBackgroundColor: changes.data.currentValue.hoverBackgroundColor
            }
          ];
        } else {
          this.datasets = [
            {
              type: this.type,
              fill: true,
              tension: 0.5,
              borderCapStyle: 'butt',
              pointHoverBorderColor: changes.data.currentValue.backgroundColor,
              pointHoverBackgroundColor: changes.data.currentValue.backgroundColor,
              pointBackgroundColor: changes.data.currentValue.backgroundColor,
              pointBorderColor: changes.data.currentValue.backgroundColor,
              data: changes.data.currentValue.values,
              label: changes.data.currentValue.titulo,
              backgroundColor: changes.data.currentValue.backgroundColor,
              borderColor: changes.data.currentValue.backgroundColor,
              hoverBackgroundColor: changes.data.currentValue.hoverBackgroundColor
            }
          ];
        }

        // setar configurações dos gráficos.
        this.setConfigChart(changes);

        setTimeout(() => { this.visible = true; }, 1);
    }
  }

  // Método responsável por exibir o gráfico.
  isVisible() {
    return this.visible;
  }

  /**
   * Método responsável por configurar o gráfico.
   * @param changes variável que registra os valores dos gráficos.
   */
  private setConfigChart(changes: any) {
    if (!changes.data.currentValue.config) {
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' },
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: changes.data.currentValue.tituloEixoY
            },
            ticks: { beginAtZero: true }
          }]
        }
      };
    } else {
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' },
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: changes.data.currentValue.tituloEixoY
            },
            ticks: { beginAtZero: true }
          }]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const label = dataset.label ? (dataset.label + ': ') : '';
              return label + this.decimalPipe.transform(dataset.data[tooltipItem.index], '1.2-2');
            }
          },
        }
      };
    }
  }
}
